import { CurrentUserState } from "app/shared/currentUser/state";
import {Action, ActionType} from 'app/actions';

export function reducer(state: CurrentUserState|undefined, action: Action) {
    if (state === undefined) {
        state = {
            version: '',
            user: {
                fullName: '',
                email: '',
                initials: '??',
                permissionList: [],
                monthsThreshold: 0
            }
        }
    }

    switch(action.type) {
        case ActionType.Startup:
            return {
                ... state,
                user: action.user,
                version: action.version
            }
        default:
            return state;
    }
}